export const SET_CURRENT_COMPANY_BALANCE_SHEET =
  "SET_CURRENT_COMPANY_BALANCE_SHEET";
export const SET_CURRENT_COMPANY_PROFIT_AND_LOSS =
  "SET_CURRENT_COMPANY_PROFIT_AND_LOSS";
export const SET_CURRENT_COMPANY_BALANCE_SHEET_REPORT =
  "SET_CURRENT_COMPANY_BALANCE_SHEET_REPORT";
export const SET_CURRENT_COMPANY_BALANCE_SHEET_REPORT_SUMMARY =
  "SET_CURRENT_COMPANY_BALANCE_SHEET_REPORT_SUMMARY";
export const SET_CURRENT_RECONCILIATION_OF_VALUATION_METHODS_REPORT =
  "SET_CURRENT_RECONCILIATION_OF_VALUATION_METHODS_REPORT";
export const SET_CURRENT_GOODWILL_REPORT = "SET_CURRENT_GOODWILL_REPORT";
export const SET_STOCK_DEAL_SPLIT_REPORT = "SET_STOCK_DEAL_SPLIT_REPORT";
export const SET_ASSET_SALE_DEAL_SPLIT_REPORT =
  "SET_ASSET_SALE_DEAL_SPLIT_REPORT";
export const SET_OWNER_FINANCING_STOCK_SALE_REPORT =
  "SET_OWNER_FINANCING_STOCK_SALE_REPORT";
export const SET_ASSET_SALE_PROCEEDS_WORKSHEET =
  "SET_ASSET_SALE_PROCEEDS_WORKSHEET";
export const SET_CURRENT_COMPANY_MONTHLY_BALANCE_SHEET =
  "SET_CURRENT_COMPANY_MONTHLY_BALANCE_SHEET";
export const SET_CURRENT_COMPANY_MONTHLY_PROFIT_AND_LOSS =
  "SET_CURRENT_COMPANY_MONTHLY_PROFIT_AND_LOSS";
export const SET_CURRENT_COMPANY_CASH_FLOW = "SET_CURRENT_COMPANY_CASH_FLOW";
export const SET_CURRENT_COMPANY_WORKING_CAPITAL =
  "SET_CURRENT_COMPANY_WORKING_CAPITAL";
